import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class Redirector extends Component {
    render() {
        const { permissions } = this.props;

        if (permissions.business || permissions.restaurant) {
            return <Redirect to={{ pathname: '/business' }} />;
        }
        if (permissions.budgets || permissions.company) {
            return <Redirect to={{ pathname: '/budgets' }} />;
        }
        if (permissions.loyalty) {
            return <Redirect to={{ pathname: '/loyaltyPrograms' }} />;
        }

        return <Redirect to={{ pathname: '/login' }} />;
    }
}

Redirector.propTypes = {
    permissions: PropTypes.object,
};

const mapStateToProps = (state) => {
    const { permissions } = state.auth;

    return { permissions };
};

export default connect(mapStateToProps)(Redirector);
